import { OktaAuth } from '@okta/okta-auth-js'
import { REACT_APP_OKTA_ISSUER } from '../../../config'

const issuer = REACT_APP_OKTA_ISSUER
export const oktaAuth = new OktaAuth({ issuer })
